import { inject, Injectable } from "@angular/core";
import { COMMONS_NAVIGATION_SERVICE, CommonsNavigationService } from "@jack-sparrow-libraries/angular-business-commons";
import { DojoRoutesEnum } from "@core/layout/enums/layout-routes.enum";
import { NavigationService } from "@services/navigation.service";

@Injectable({ providedIn: "root" })
export class CommonsNavigationAyService implements CommonsNavigationService {
	private readonly navigationService = inject(NavigationService);

	navigateToOrdonnancesPatient(patientId: number): void {
		void this.navigationService.navDojo([DojoRoutesEnum.ORDONNANCES, patientId, DojoRoutesEnum.LISTE_ORDONNANCES]);
	}
}

export const provideCommonsNavigationService = () => ({
	provide: COMMONS_NAVIGATION_SERVICE,
	useExisting: CommonsNavigationAyService,
});
